import { render, staticRenderFns } from "./menubottom.vue?vue&type=template&id=f7715bce&scoped=true&"
import script from "./menubottom.vue?vue&type=script&lang=js&"
export * from "./menubottom.vue?vue&type=script&lang=js&"
import style0 from "./menubottom.vue?vue&type=style&index=0&id=f7715bce&scoped=true&lang=css&"
import style1 from "./menubottom.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7715bce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBottomSheet,VCard,VDivider,VFlex,VImg,VSheet,VSwitch})
